import { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import io from "socket.io-client";
import Modal from "../modal";
import { useValidacionFormulario } from "../../hooks/validacion";
import { ActualizaAcompanante, getTiposDocumentos} from "../../services/beneficiario";

const AcompananteModal = ({ show, handleshow, HistoriaId, Lector, Url, onGuardado }) => {
  const [habilita, setHabilita] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [opciones, setOpciones] = useState([]);
  const [tiposdoc, setTipoDoc] = useState([]);
  const camposMayusculas = ["NombreAcomp"];
  const [activalect, setActivaLect]= useState(true);

  const [datas, setDatas] = useState({
                                      HistoriaId:HistoriaId, 
                                      AcompantId: 0,
                                      TipoDoc: "",
                                      NUmeroNit: "",
                                      NombreAcomp: "",
                                      SexoAcomp: "",
                                      Parentesco: 0,
                                      TelefAcomp: ""
                                      });
  const {validarCampos, limpiarError, claseLabel, claseCampo,} = useValidacionFormulario(datas);

//----------------------------------------------------------------------------------------------------------------------  
  const handleChangeSolicitante = (e) => {
  const { name, value, type, checked } = e.target;
    setDatas((prev) => ({
       ...prev,
       [name]:
         type === "checkbox"
          ? checked ? "SI" : "NO"
          : camposMayusculas.includes(name)
          ? value.toUpperCase()
          : value,
    }));
    limpiarError(name);
    setHabilita(false);
  };
//----------------------------------------------------------------------------------------------------------------------
  const handleAceptar = async () => 
    {
      const esValido = validarCampos(["TipoDoc","NumeroNit","NombreAcomp","SexoAcomp",'Parentesco']);
      if (!esValido) return;
  
      setHabilita(true);
      setShowToast(false);
      const response = await ActualizaAcompanante(datas);
      if (response) 
        {
          if (response.status === 200) 
            {
              onGuardado(response.data.data); 
              handleshow(false);
            } 
          else 
            {
              const Mensaje = response.message;
              const opc = { type: "Danger", message: Mensaje, active: true };
              setOpciones(opc);
              setShowToast(true);
            }
        }
      setHabilita(false);
    };
//----------------------------------------------------------------------------------------------------------------------
  const handleCancel = async () => 
    {
      handleshow(false);
    };
//----------------------------------------------------------------------------------------------------------------------
  const ObtenerTiposDoc = async () =>
    {
      setShowToast(false);
      const response = await getTiposDocumentos();
      if (response) 
       {
         if (response.status === 200)
          setTipoDoc(response.data.data) 
         else 
          {
            const Mensaje = response.message;
            const opc = { type: "Danger", message: Mensaje, active: true };
            setOpciones(opc);
            setShowToast(true);
          }
       }
    }
//----------------------------------------------------------------------------------------------------------------------
useEffect(() => 
  {
    ObtenerTiposDoc()
  }, []);

//----------------------------------------------------------------------------------------------------------------------
 useEffect(() => {
  if (Lector !== 'SI') return;
  
  const socket = io(Url);
  socket.on("connect",() =>{})
  socket.on("connect_error",(err) =>{console.log('Error de conexion', err.message)})
  socket.on("disconnect",() =>{})
  socket.on("barcode", (message) => 
        {
         if ((message) && (activalect))
          {
            setActivaLect(false);
            setDatas(prev => ({
             ...prev,
             TipoDoc: message.tipodoc,
             NumeroNit: message.documento,
             NombreAcomp: message.nombre_completo,
             SexoAcomp: message.genero,
            }));
          }
        });
 
  return () => {
    return socket.disconnect();
   };
  
}, [Lector, Url]);

  return (
    <>
    <Modal isOpen={show} onClose={()=>handleshow(false)} title={'Nuevo solicitante'}>
       <div className="flex w-[26rem] lg:w-[30rem]">
          <form noValidate className="flex flex-col w-full">
               <div className="flex flex-row  mt-2 gap-x-2">
                 <div className="w-full">
                    <label  className={claseLabel("TipoDoc")}>Tipo documento</label>
                    <select name="TipoDoc" value={datas.TipoDoc} onChange={handleChangeSolicitante} className={claseCampo("TipoDoc")}>
                        <option value="">Seleccione...</option>
                         {tiposdoc.map((t, index) => (
                           <option key={index} value={t.Codigo}>
                             {t.NombreParm}
                           </option>
                         ))}
                    </select>
                 </div>
                 <div className="w-full">
                    <label className={claseLabel("NumeroNit")}>Identificación</label>
                    <input type="text" name="NumeroNit" value={datas.NumeroNit} className={claseCampo("NumeroNit")} onChange={handleChangeSolicitante}/>
                 </div>
              </div>

              <div className="flex flex-row mt-4 gap-x-2">
                <div className="w-full">
                  <label className={claseLabel("NombreAcomp")}>Nombre</label>
                  <input type="text" name="NombreAcomp" value={datas.NombreAcomp} className={claseCampo("NombreAcomp")} onChange={handleChangeSolicitante}/>
                </div>    
              </div>

              <div className="flex flex-row mt-4 gap-x-2">
                 <div className="w-full">
                    <label  className={claseLabel("SexoAcomp")}>Sexo</label>
                    <select name="SexoAcomp" className={claseCampo("sexoAcomp")} value={datas.SexoAcomp} onChange={handleChangeSolicitante}>
                      <option value="">Seleccione</option>
                      <option value="M">Masculino</option>
                      <option value="F">Femenino</option>
                    </select>
                 </div>
                 <div className="w-full">
                    <label>Teléfono</label>
                    <input type="text" name="TelefonoAcomp" value={datas.TelefonoAcomp} onChange={handleChangeSolicitante}/>
                 </div>
              </div>
              <div className="flex flex-row mt-4  gap-x-2">
                <div className="w-full">
                  <label className={claseLabel("NombreAcomp")}>Tipo Solicitante</label>
                     <select name="Parentesco" value={datas.Parentesco} onChange={handleChangeSolicitante}>
                        <option value={0}>Seleccione</option>
                        <option value={1}>Padre</option>
                        <option value={2}>Madre</option>
                        <option value={3}>Hijo(a)</option>
                        <option value={4}>Hermano(a)</option>
                        <option value={5}>Pareja</option>
                        <option value={6}>Otro</option>
                     </select>
               </div>    
              </div>
              <div className="flex w-full gap-4 mt-6 justify-end">
                <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
                <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
              </div>
          </form>
       </div>   
    </Modal> 
    </>
)}
  
  AcompananteModal.propTypes = {
    show: PropTypes.bool.isRequired,
    handleshow: PropTypes.func.isRequired,
    HistoriaId: PropTypes.number.isRequired, 
    Lector: PropTypes.string,
    Url: PropTypes.string,
    onGuardado: PropTypes.func.isRequired,
  };
  
export default AcompananteModal;